var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_c('IxRes',[_vm._v("Areas.SimpleApplicationMaps.SR_SimpleApplicationMaps.Heterogenity")])],1),_c('div',[_c('IxRes',[_vm._v("Enums.SR_Enums.HeterogenityEnum_"+_vm._s(_vm.zoneMap.heterogenity || 'None'))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }